module.exports = __webpack_public_path__ + "img/icon_tag103.d2d726d3.svg";